import { toast } from "react-toastify";
import api from "./api/api";

const CadastroColaboradorService = {
  cadastrarColaborador: async (payload: any) => {
    try {
      const res = await api.post(`/users`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Colaborador cadastrado com sucesso");
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  editarContato: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/users/${id}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Editado com sucesso");
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      toast.error("Erro ao Editar Usuário");
      return error.response;
    }
  },
  deleteContato: async (id: any) => {
    try {
      const res = await api.delete(`/users/${id}`);
      toast.success("Deletado com sucesso");
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      toast.error("Erro ao Deletar Usuário");
      return error.response;
    }
  },
  verificarContato: async (id: any, isVerified: boolean, email?: string) => {
    try {
      const formData = new FormData();
      formData.append("is_verified", String(isVerified));
      if (email) formData.append("email", email);
      const res = await api.put(`/users/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res;
    } catch (error: any) {
      toast.error("Erro ao atualizar verificação do contato");
      return error.response;
    }
  },
  verificarProprioPerfil: async (isVerified: boolean) => {
    try {
      const res = await api.put(`/users/edit`, { is_verified: isVerified });
      return res;
    } catch (error: any) {
      toast.error("Erro ao verificar perfil");
      return error.response;
    }
  },
  verificarContatoExtra: async (
    userId: number,
    type: "phone" | "email",
    index: number,
    isVerified: boolean,
  ) => {
    try {
      const res = await api.patch(`/users/${userId}/verify-contact`, {
        type,
        index,
        is_verified: isVerified,
      });
      return res;
    } catch (error: any) {
      toast.error("Erro ao atualizar verificação");
      return error.response;
    }
  },
  listarAgencia: async () => {
    try {
      const res = await api.get(`/agencys`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  listarGroups: async () => {
    try {
      const res = await api.get(`/profile_users`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  listarGroupFunction: async (id_group: any) => {
    try {
      const res = await api.get(`/group_profile/${id_group}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default CadastroColaboradorService;
